import { Category } from "types/model.types";
import { authApi } from "./";

export const getCategories = async () => {
  const response = await authApi.get("category/get");
  return response ?? [];
};

export const updateCategory = async (c: Category) => {
  const url = `category/${
    c.id === undefined || c.id === "" || c.id === 0 ? "add" : "update"
  }`;
  const response = await authApi.post(url, {
    nm: c.name,
    id: c.id,
  });

  return response;
};

export const deleteCategoryById = async (id: string | number) => {
  const response = await authApi.post("category/delete", {
    id,
  });

  return response;
};
